import { render, staticRenderFns } from "./workWomenCorps.vue?vue&type=template&id=4906820a&scoped=true"
import script from "./workWomenCorps.vue?vue&type=script&lang=js"
export * from "./workWomenCorps.vue?vue&type=script&lang=js"
import style1 from "./workWomenCorps.vue?vue&type=style&index=1&id=4906820a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4906820a",
  null
  
)

export default component.exports